import { useEffect } from 'react';

import { removeCookies } from '../helpers/utils.helper';

export const useAppInit = () => {
  useEffect(() => {
    removeCookies();
  }, []);
};
